import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

import buysellapp_logo from '../../utils/imgs/buysellapp_logo.png';

// A functional component representing a logo
const Logo = ({
    nav: {
        website,
        website_loading
    }
}) => {

    let app_logo = buysellapp_logo

    // -- Custom URL Logic --

    if(website?.website_logo) {
        app_logo = website?.website_logo
    }

    // -- END: Custom URL Logic --

     // Render an image element with the logo
    return (
        <Fragment>
            {/* Custom URL Logic -- */}
            {!website_loading ? 
                <img className="modal__twitterIcon" src={app_logo} style={{height: '40px'}} alt="logo" />
                :
                <div className='modal__twitterIcon' style={{height: '40px'}}></div>
            }
            {/* END: Custom URL Logic -- */}
        </Fragment>
    );
}

Logo.propTypes = {
    nav: PropTypes.object.isRequired, // Prop: Object representing navigation state
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    nav: state.nav
})

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
})(Logo);
